// API Configuration
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001/api'

// Auth: token keys for localStorage. All apps will be hosted on Okta (future integration).
export const AUTH_TOKEN_KEY = 'token'
export const REFRESH_TOKEN_KEY = 'refresh_token'
